import { render, staticRenderFns } from "./SmartForms.vue?vue&type=template&id=42670fd0&"
import script from "./SmartForms.vue?vue&type=script&lang=ts&"
export * from "./SmartForms.vue?vue&type=script&lang=ts&"
import style0 from "./SmartForms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports